var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"inline-flex"}},[_c('div',{staticClass:"type-tabs"},_vm._l((_vm.options),function(option){return _c('div',{key:option.value,staticClass:"type-tab-item",class:{ active: _vm.value === option.value },on:{"click":function($event){return _vm.handleTabClick(option.value)}}},[_vm._v(" "+_vm._s(option.label)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }